import React from 'react';
import { useTranslation } from 'react-i18next';

function Welcome() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div
        className={`${
          i18n.language === 'en' ? 'row' : 'd-flex flex-row-reverse flex-wrap'
        } mx-0 pb-2`}>
        <span className={`${i18n.language === 'en' ? 'ms-5' : 'me-5'} my-3 subtitle fs-5`}>
          <strong>{t('welcomePage.title')}</strong>
        </span>
      </div>
      <div className='row px-5 mx-0'>
        <img src='/invoice.png' alt='Invoice' style={{ height: '385px' }} />
      </div>
      <div
        className={`${i18n.language === 'en' ? 'row' : 'd-flex flex-row-reverse flex-wrap'} mx-0`}>
        <div className='col-9'>
          <div
            className={`${
              i18n.language === 'en' ? 'row' : 'd-flex flex-row-reverse flex-wrap'
            } mx-0`}>
            <span
              className={`${
                i18n.language === 'en' ? 'ms-5 me-3' : 'me-5 ms-3'
              } mt-5 subtitle fs-6 fw-bold`}>
              {t('welcomePage.about')}
            </span>
          </div>
          <div
            className={`${
              i18n.language === 'en' ? 'row' : 'd-flex flex-row-reverse flex-wrap'
            } mx-0`}>
            <section className={`${i18n.language === 'en' ? 'ms-5 me-3' : 'me-5 ms-3'} mt-3`}>
              {t('welcomePage.firstSection')}
            </section>
            <section className={`${i18n.language === 'en' ? 'ms-5' : 'me-5 text-end'} mt-3`}>
              {t('welcomePage.secondSection')}
            </section>
            <section className={`${i18n.language === 'en' ? 'ms-5' : 'me-5 text-end'} mt-3`}>
              {t('welcomePage.thirdSection')}
            </section>
            <section className={`${i18n.language === 'en' ? 'ms-5' : 'me-5 text-end arabic'} mt-3`}>
              {t('welcomePage.fourthSection')}
            </section>
            <section className={`${i18n.language === 'en' ? 'ms-5' : 'me-5 text-end arabic'} mt-3`}>
              <ul>
                <li>{t('welcomePage.fifthSection.firstListElement')}</li>
                <li>{t('welcomePage.fifthSection.secondListElement')}</li>
                <li>{t('welcomePage.fifthSection.thirdListElement')}</li>
                <li>{t('welcomePage.fifthSection.fourthListElement')}</li>
                <li> {t('welcomePage.fifthSection.fifthListElement')}</li>
                <li>{t('welcomePage.fifthSection.sixthListElement')}</li>
              </ul>
            </section>
            <section className={`${i18n.language === 'en' ? 'ms-5' : 'me-5'} my-3`}>
              <strong>{t('welcomePage.sixthSection')}</strong>
            </section>
          </div>
        </div>
        {/* <div className='col-2'>
                <div className='row mb-5 mx-5'>
                  <div className='row text-start'>
                    <span
                      className='mt-5 me-3 subtitle fs-6 text-nowrap text-decoration-underline'
                      style={{ textUnderlineOffset: '10px' }}>
                      Quick Links
                    </span>
                  </div>
                  <span className='row mt-4 ms-2 text-nowrap'>About Sobol</span>
                  <span className='row mt-4 ms-2 text-nowrap'>User Guide</span>
                  <span className='row mt-4 ms-2 text-nowrap'>Privacy Policy</span>
                  <span className='row mt-4 ms-2 text-nowrap'>Terms and conditions</span>
                </div>
              </div> */}
      </div>
    </>
  );
}

export default Welcome;
